(() => {
	const tilemodule = document.querySelector('.tilemodule');
	const tileitems = document.querySelectorAll('.tilemodule__item');

	const openTile = tile => {
		let closingTile = tile.nextElementSibling;
		if(closingTile) {
			closingTile.classList.add('tilemodule__item--left');
		} else {
			closingTile = tile.previousElementSibling;
			closingTile.classList.add('tilemodule__item--right');
		}

		tile.classList.add('tilemodule__item--open');
		tilemodule.classList.add('tilemodule--active');
	};

	const closeTiles = () => {
		tileitems.forEach(item => {
			item.classList.remove('tilemodule__item--open');
			item.classList.remove('tilemodule__item--active');
			item.classList.remove('tilemodule__item--left');
			item.classList.remove('tilemodule__item--right');
		});
		tilemodule.classList.remove('tilemodule--active');
	};

	tileitems.forEach(item => {
		item.addEventListener('click', function() {
			if(tilemodule.classList.contains('tilemodule--active')) {
				closeTiles();
			} else {
				openTile(item);
			}
		});

		item.addEventListener('transitionend', function(e) {
			if(e.propertyName.includes('flex')) {
				if(this.classList.contains('tilemodule__item--open')) {
					this.classList.add('tilemodule__item--active');
				}
			}
		});
	});

	const thumbnails = document.querySelectorAll('.mbtilemodule__thumbnaillist-item');
	const thumbnailWrapper = document.querySelector('.mbtilemodule__thumbnaillist');

	const hideFeatureItems = () => {
		const activeItems = document.querySelectorAll('.mbtilemodule__item--active');
		activeItems.forEach(item => {
			item.classList.remove('mbtilemodule__item--active');
		});
	};
	
	const hideThumbnails = () => {
		const activeItems = document.querySelectorAll('.mbtilemodule__thumbnaillist-item--hidden');
		activeItems.forEach(item => {
			item.classList.remove('mbtilemodule__thumbnaillist-item--hidden');
		});
	};

	thumbnails.forEach(thumbnail => {
		thumbnail.addEventListener('click', function() {
			hideFeatureItems();
			document.querySelector(`#${thumbnail.dataset.controls}`).classList.add('mbtilemodule__item--active');
			
			thumbnailWrapper.classList.add('mbtilemodule__thumbnaillist--active');
			hideThumbnails();
			this.classList.add('mbtilemodule__thumbnaillist-item--hidden');
		});
	});

})();
